import Tag from './styled';

export default Tag;
